<template>
  <div :class="widthClass" class="CustomInput lxn-pos-rel">
    <input
      :disabled="disabled"
      v-bind:value="value"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
      v-on:input="$emit('input', $event.target.value)"
      :class="[$store.getters.language.font, $store.getters.language.directionClass, errorClass]"
      :type="inputType"
      class="CustomInput-input lxn-h100 lxn-w100 lxn-title lxn-border-round lxn-text-center"
      :style="inputStyle"
      :placeholder="inputPlaceHolder"
    />
    <div v-if="inputState" :class="inputState" class="CustomInput-wrapper-statusBar lxn-pos-abs"></div>
    <div
      v-if="error !== undefined && error.hasError"
      :class="[this.$store.getters.language.directionClass, $store.getters.language.textAlignClass, $store.getters.language.font]"
      class="lxn-input-error-span"
    >
      {{ error.message }}
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomInput",
  components: {},
  props: {
    placeHolder: String,
    value: [String, Number],
    inputType: String,
    inputState: String,
    bgColor: String,
    width: String,
    disabled: Boolean,
    error: Object,
  },
  data: function () {
    return {
      inputBgColor: this.bgColor || "#ECECEC",
    };
  },
  methods: {},
  computed: {
    errorClass: function () {
      if (this.error !== undefined && this.error.hasError) {
        return "lxn-input-error";
      } else {
        return "";
      }
    },
    inputPlaceHolder: function () {
      return this.placeHolder;
    },
    inputStyle: function () {
      var inputStyle = "";
      inputStyle += "background-color: " + this.inputBgColor + ";";
      if (!isNaN(this.width)) {
        inputStyle += "width: " + this.width + "px;";
      }
      return inputStyle;
    },
    widthClass: function () {
      if (this.width !== undefined) {
        return "lxn-w" + this.width;
      } else if (isNaN(this.width)) {
        return "lxn-w100";
      } else {
        return "lxn-undefined";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.CustomInput {
  height: 50px;
}
.CustomInput-input {
  color: #52626c;
}
.CustomInput-wrapper-statusBar {
  height: 4px;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
}
.CustomInput-wrapper-statusBar.selected {
  background-color: #1ea5de;
}
.CustomInput-wrapper-statusBar.error {
  background-color: #f36c4f;
}
.CustomInput-wrapper-statusBar.active {
  background-color: #b8b8b8;
}
</style>
